import { createAction } from 'typesafe-actions';
import { ITrapFarmDescription } from '../../../../types/model/masterData/trap/farmDescription';

export default class TrapFarmDescriptionActions {
    public static setLoading = createAction('MASTER_DATA_TRAP_FARM_DESCRIPTION_SET_LOADING', resolve => (loading : boolean) => resolve(loading));
    public static setList = createAction('MASTER_DATA_TRAP_FARM_DESCRIPTION_SET', resolve => (items : Array<ITrapFarmDescription>) => resolve(items));
}